import { useSelector } from 'react-redux'
import { Row } from "react-bootstrap";
import { useState, useEffect } from 'react';
import { Table, Form, Empty } from 'antd';
import { getHistoryDetail } from '../../../libs/historySlice';
import { getObjective } from '../../../libs/todoSlice'
import { resolvePreRegisterConfig, buildFieldColumns } from '../../../lib/preRegisterConfig'

/**
 * Generic — แทน ThaIDHistoryDetailSuccess.jsx
 * แสดงรายการที่ลงทะเบียนสำเร็จ (ย้อนหลัง จาก history) ใช้ config.fields
 * แทน hardcode cid/id_card_type เพื่อรองรับทุกประเภทที่มี fields schema
 */
const PreRegisterHistoryDetailSuccess = () => {
    const details = useSelector(getHistoryDetail)
    const lastHistory = details.importHistories[details.importHistories.length - 1]
    const config = resolvePreRegisterConfig(lastHistory.objective ?? [])
    const [form] = Form.useForm();
    const [data, setData] = useState([]);

    useEffect(() => {
        

        setData(details.importHistories[details.importHistories.length - 1].successDetail.map((items, index) => ({
            index: index + 1,
            ...Object.fromEntries(config.fields.map(f => [f.key, items.request?.[f.key] ?? '-'])),
        })))
    }, [details.importHistories, config])

    const customLocale = {
        emptyText: (<Empty description="ไม่มีข้อมูล" />)
    };

    const columns = [
        {
            title: 'ลำดับที่',
            width: 100,
            render: (_, __, index) => index + 1,
        },
        ...buildFieldColumns(config),   // read-only
    ];

    return (
        <Row>
            <Form form={form} component={false}>
                <Table
                    locale={customLocale}
                    bordered
                    dataSource={data}
                    columns={columns}
                    rowKey="index"
                    rowClassName="editable-row"
                    scroll={{ x: 900, y: 400 }}
                />
            </Form>
        </Row>
    )
}
export default PreRegisterHistoryDetailSuccess